import React = require("react");
import l10n from "diy/util/l10n";

let survey: any = require('diy/survey/survey');

interface RatingProps {
    showAlternative?: boolean;
}

export default class Rating extends React.Component<RatingProps, {}> {
    static defaultProps = {
        showAlternative: false
    };
    constructor(props: RatingProps) {
        super(props);
    };

    render() {
        const styles = this.getStyles();
        if (this.props.showAlternative) {
            return (<div style={styles.root}>
                    <p style={styles.text}>
                        {l10n('maintenance.dialog.ratingAlternative') }
                    </p>
                </div>);
        } else {
            if (survey.isSurveyEnabled()) {
                return (<div style={styles.root}>
                        <p style={styles.text}>
                            {l10n('maintenance.dialog.ratingPreText')}&nbsp;
                            <a
                                style={styles.link}
                                onClick={() => {
                                    survey.showFromPublishCongratulations(true);
                                }}
                                tabIndex={-1}
                                >{l10n('maintenance.dialog.ratingLinkText')}</a>&nbsp;
                                {l10n('maintenance.dialog.ratingAfterText')}
                        </p>
                    </div>);
            } else {
                return null;
            }
        }
    };

    private getStyles() {
        return {
            root: {
                padding: "0 20px"
            },
            text: {
                fontSize: "14px",
                fontWeight: "normal",
                textAlign: "center",
                marginBottom: 0,
                paddingTop: "13px",
                paddingBottom: "13px"
            } as React.CSSProperties,
            link: {
                cursor: "pointer",
                color: "#08c",
                textDecoration: "none"
            }
        };
    };
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/moments-to-celebrate/components/Rating.tsx
 **/